import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const delta = 2;

  const generatePageNumbers = () => {
    const pages = [];
    const range = [];

    const left = Math.max(currentPage - delta, 0);
    const right = Math.min(currentPage + delta, totalPages - 1);

    // Add start page
    if (left > 0) {
      pages.push(0);
      if (left > 1) pages.push("...");
    }

    // Add middle pages
    for (let i = left; i <= right; i++) {
      pages.push(i);
    }

    // Add end page
    if (right < totalPages - 1) {
      if (right < totalPages - 2) pages.push("...");
      pages.push(totalPages - 1);
    }

    return pages;
  };

  const pageNumbers = generatePageNumbers();

  return (
    <nav>
      <ul className="pagination justify-content-center">
        <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 0}
          >
            <FiChevronLeft color="#adb5bd" />
          </button>
        </li>

        {pageNumbers.map((page, idx) => (
          <li
            key={idx}
            className={`page-item ${
              page === currentPage ? "active" : page === "..." ? "disabled" : ""
            }`}
          >
            {page === "..." ? (
              <span className="page-link">…</span>
            ) : (
              <button className="page-link" onClick={() => onPageChange(page)}>
                {page + 1}
              </button>
            )}
          </li>
        ))}

        <li
          className={`page-item ${
            currentPage === totalPages - 1 ? "disabled" : ""
          }`}
        >
          <button
            className="page-link"
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages - 1}
          >
            <FiChevronRight color="#adb5bd" />
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
